import styled from 'styled-components'
import {Container} from 'reactstrap'
import styledBy from 'styled-by'
import {down} from 'styled-breakpoints'

import {colors} from '~/constants/style'
import {withInnerWrapper} from '~/hocs'

const Footer = styled(
  withInnerWrapper(Container)('div'),
)`
  background: url('https://res.cloudinary.com/ngabds/image/upload/f_auto,q_auto/v1617420000/static-images/Utah-Triana_CC_RET_zeo4yw.jpg') no-repeat center / cover;
  padding-top: 50px;
  padding-bottom: 50px;
  position: relative;
  color: white;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
  }
`

Footer.SectionsWrapper = styled.div`
  ${down('sm')} {
    margin-bottom: -50px;
  }
`

Footer.Section = styled.div`
  ${down('sm')} {
    margin-bottom: 50px;
  }
`

Footer.SectionHeading = styled.div`
  font-size: 2rem;
  margin-bottom: 30px;

  ${down('sm')} {
    text-align: center;
  }
`

Footer.Logo = styled.img`
  height: 120px;
  width: auto;
`

Footer.SectionBody = styled.div`
  a {
    color: white;

    &:hover {
      text-decoration: none;
      color: ${colors.green};
    }
  }
`

Footer.ContactItem = styled.div`
  &:not(:last-child) {
    margin-bottom: 7px;
  }
`

Footer.SocialItemsWrapper = styled.div`
  display: flex;
`

Footer.SocialItem = styled.a`
  display: inline-block;
  font-size: 2.3rem;
  
  &&:hover {
    text-decoration: none;
    color: ${styledBy('name', {facebook: '#475993', youtube: '#F61C0E'})}
  }

  &:not(:last-child) {
    margin-right: 22px;
  }
`

export default Footer
